<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Acompanhamento bimestral do plano de aula
        </h1>
      </v-col>
    </v-row>
    <v-row class="d-flex align-center">
      <v-col cols="2">
        <v-card-text class="d-flex align-center">
          <v-icon medium class="mr-2">mdi mdi-file-table</v-icon>
          <h4>Relatórios:</h4>
        </v-card-text>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn @click="relatorioAcompanhamento()" block small class="primary">
          <span class="">Acompanhamento bimestral do plano de aula</span>
          <v-icon right>mdi mdi-download</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" class="d-flex mb-2 pt-0 pb-0">
        <div class="ml-auto">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Procurar"
            single-line
            hide-details
          >
          </v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="acompanhamentosList"
          :loading="carregandoAcompanhamentos"
          :items-per-page="10"
          hide-default-footer
          no-data-text="Não foram encontrádos vínculos para você, por favor entre em contato com a secretaria/coordenação para que lhe adicionem acesso às turmas e Componentes Curriculares"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="
                  gestaoDeAulas.estaDeletado
                    ? ['deleted']
                    : parseInt(gestaoDeAulas.notifiq, 10) === 1
                    ? 'green lighten-5'
                    : ''
                "
                v-for="gestaoDeAulas of items"
                :key="gestaoDeAulas.id"
              >
                <td>{{ gestaoDeAulas.id }}</td>
                <td>
                  {{ gestaoDeAulas.nomeFranquia ? gestaoDeAulas.nomeFranquia : "- - -" }}
                </td>
                <td>
                  {{ gestaoDeAulas.nomeProfessor ? gestaoDeAulas.nomeProfessor : "- - -" }}
                </td>
                <td>
                  {{ gestaoDeAulas.nomeTurma ? gestaoDeAulas.nomeTurma : "- - -" }}
                </td>
                <td v-if="gestaoDeAulas.disciplinas.length">
                  <div v-for="(item, index) in gestaoDeAulas.disciplinas" :key="index">
                    <v-chip x-small>{{ item.descricao }} </v-chip>
                  </div>
                </td>
                <td v-else>
                  {{ gestaoDeAulas.nomeDisciplina ? gestaoDeAulas.nomeDisciplina : "- - -" }}
                </td>

                <td>
                  <div class="text-center">
                    <v-menu :close-on-content-click="false" :nudge-width="100" offset-x>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small color="indigo" dark v-bind="attrs" v-on="on"> AÇÕES </v-btn>
                      </template>

                      <v-card class="mx-auto" max-width="430">
                        <v-list>
                          <v-list-item>
                            <v-list-item-avatar color="primary">
                              <v-list-item-title
                                v-if="gestaoDeAulas.disciplinas.length"
                                style="color: #fff"
                              >
                                {{
                                  gestaoDeAulas.disciplinas.descricao
                                    ? gestaoDeAulas.disciplinas.descricao
                                        .substring(0, 1)
                                        .toUpperCase()
                                    : "P"
                                }}
                              </v-list-item-title>
                              <v-list-item-title v-else style="color: #fff">
                                {{
                                  gestaoDeAulas.disciplina?.descricao
                                    ? gestaoDeAulas.disciplina?.descricao
                                        .substring(0, 1)
                                        .toUpperCase()
                                    : "- - -"
                                }}
                              </v-list-item-title>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title>
                                {{
                                  gestaoDeAulas.nomeProfessor
                                    ? gestaoDeAulas.nomeProfessor
                                    : "- - -"
                                }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{ gestaoDeAulas.nomeTurma ? gestaoDeAulas.nomeTurma : "- - -" }}
                                /
                                {{
                                  gestaoDeAulas.nomeDisciplina
                                    ? gestaoDeAulas.nomeDisciplina
                                    : "- - -"
                                }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <!-- item -->

                        <v-list>
                          <v-list-item-group v-if="!gestaoDeAulas.estaDeletado" color="primary">
                            <v-list-item
                              v-if="gestaoDeAulas.is_polivalencia"
                              @click="
                                escolherDisciplina(
                                  gestaoDeAulas.id,
                                  gestaoDeAulas.disciplinas,
                                  'acompanhamentos'
                                )
                              "
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-file-alt</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title
                                  >Lançar acompanhamento bimestral <br />do plano de aula
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              v-else
                              :to="{
                                name: 'acompanhamentosBimestrais.newEdit',
                                params: {
                                  gestaoDeAulaId: gestaoDeAulas.id,
                                  disciplinaId: gestaoDeAulas.disciplina_id,
                                },
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-file-alt</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title
                                  >Lançar acompanhamento bimestral <br />do plano de aula
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="handlePageChange"
          :search="search"
        >
        </e-paginate>
      </v-col>
    </v-row>
    <e-escolha-disciplina
      @status="abrirModalEscolha = $event"
      :dialog="abrirModalEscolha"
      :gestaoDeAulasId="gestaoDeAulasEscolhida"
      :disciplinas="disciplinasArray"
      :typeModel="typeModel"
    ></e-escolha-disciplina>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import GestaoDeAula from "@/Models/GestaoDeAula";

export default {
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  data() {
    return {
      typeModel: null,
      search: localStorage.getItem("acompanhamentosBimestrais_search") || "",
      acompanhamentosList: [],
      pageNumber: parseInt(localStorage.getItem("acompanhamentosBimestrais_current_page"), 10) || 1,
      carregandoAcompanhamentos: false,
      paginate: {
        current_page:
          parseInt(localStorage.getItem("acompanhamentosBimestrais_current_page"), 10) || 1,
        last_page: 0,
      },
      abrirModalEscolha: false,
      table: {
        headers: [
          {
            text: "#",
            value: "id",
          },
          {
            text: "Escola",
            value: "nomeFranquia",
          },
          {
            text: "Professor",
            value: "nomeProfessor",
          },
          {
            text: "Turma",
            value: "nomeTurma",
          },
          {
            text: "Componente(s) Curricular(es)",
            value: "nomeDisciplina",
          },

          {
            text: "",
            value: "actions",
            sortable: false,
            width: "200px",
          },
        ],
      },
      disciplinasArray: [],
      gestaoDeAulasEscolhida: null,
    };
  },
  async mounted() {
    // this.$loaderService.open("Carregando acompanhamentos");
    try {
      await this.listarAcompanhamentos(this.pageNumber, this.search);
    } catch (error) {
      // this.$handleError(error);
    }
    // this.$loaderService.close();
  },
  watch: {
    carregandoAcompanhamentos(value) {
      if (value && this.acompanhamentosList.length === 0) {
        this.$loaderService.open("Carregando acompanhamentos");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      localStorage.setItem("acompanhamentosBimestrais_search", val); // Corrigido aqui
      if (val.length > 2) {
        await this.listarAcompanhamentos(0, val);
      }
      if (!val) {
        await this.listarAcompanhamentos(0);
      }
    },
  },
  methods: {
    escolherDisciplina(idGestao, disciplinas, type) {
      this.abrirModalEscolha = true;
      this.disciplinasArray = disciplinas;
      this.gestaoDeAulasEscolhida = idGestao;
      this.typeModel = type;
    },
    goBack() {
      if (this.user.role.name.includes("professor")) {
        this.$router.push({
          name: "acessoProfessor.home",
        });
      }
      this.$router.push({
        name: "home",
      });
    },
    async listarAcompanhamentos(pageNumber, query = null) {
      this.carregandoAcompanhamentos = true;
      try {
        this.$loaderService.open("Carregando acompanhamentos");
        const response = await this.$services.gestoesDeAulasService.syncAll(pageNumber, query);
        this.acompanhamentosList = await response.data
          .map((gestao) => new GestaoDeAula(gestao))
          .sort((a, b) => a.professor.nome.localeCompare(b.professor.nome));

        this.paginate = response;
      } catch {
        this.$handleError(error);
      }
      this.carregandoAcompanhamentos = false;
    },
    async relatorioAcompanhamento() {
      this.carregandoAcompanhamentos = true;
      try {
        await this.$services.acompanhamentosService.relatorioAcompanhamentoBimestral(
          parseInt(this.user.configuracao_id, 10)
        );
      } catch {
        this.carregandoAcompanhamentos = false;
      }
      this.carregandoAcompanhamentos = false;
    },
    handlePageChange(page) {
      this.listarAcompanhamentos(page, this.search);
      this.pageNumber = page;
      localStorage.setItem("acompanhamentosBimestrais_current_page", page);
    },
  },
};
</script>

<style></style>
